import { generateAnonBase64Hash } from "@utils/anonymous";
import { usePrefs } from "@utils/client-side-preferences";

import { OrderRow, TableHeader } from "./order-table";

export interface CustomerDetailsProps {
  customerDetails: {
    customerEmail: string;
    customerFirstName: string;
    customerId: string;
    customerPhone: string;
    orderType: string;
    shippingAddress1: string;
    shippingAddress2: string;
    shippingCity: string;
    shippingCountry: string;
    shippingCountryCode: string;
    shippingProvince: string;
    shippingProvinceCode: string;
    shippingZip: string;
  };
}

export const CustomerDetails = ({ customerDetails }: CustomerDetailsProps) => {
  const prefs = usePrefs();
  const isAnon = prefs.isDemoMode;
  return (
    <>
      <div className="flex gap-1 items-center w-full pt-6">
        <span className="text-xs font-bold uppercase text-v2-primary">
          Customer Details
        </span>
      </div>
      <div className="overflow-auto rounded border border-solid border-v2-secondary">
        <TableHeader />
        <div>
          <OrderRow
            type="Customer ID"
            details={
              isAnon
                ? generateAnonBase64Hash({
                    value: customerDetails?.customerId,
                    prefix: "customerId",
                    doAnon: isAnon,
                  })
                : customerDetails?.customerId
            }
            isAlternate={false}
          />
          <OrderRow
            type="First Name"
            details={
              isAnon
                ? generateAnonBase64Hash({
                    value: customerDetails?.customerFirstName,
                    prefix: "customerFirstName",
                    doAnon: isAnon,
                  })
                : customerDetails?.customerFirstName
            }
            isAlternate={true}
          />
          <OrderRow
            type="Email"
            details={
              isAnon
                ? generateAnonBase64Hash({
                    value: customerDetails?.customerEmail,
                    prefix: "customerEmail",
                    doAnon: isAnon,
                  })
                : customerDetails?.customerEmail
            }
            isAlternate={false}
          />
          <OrderRow
            type="Order Type"
            details={customerDetails?.orderType}
            isAlternate={false}
          />
          <OrderRow
            type="Shipping Address"
            details={
              isAnon
                ? generateAnonBase64Hash({
                    value: customerDetails?.shippingAddress1,
                    prefix: "shippingAddress1",
                    doAnon: isAnon,
                  })
                : [
                    customerDetails?.shippingAddress1,
                    customerDetails?.shippingCity,
                    customerDetails?.shippingProvince,
                    customerDetails?.shippingZip,
                    customerDetails?.shippingCountry,
                  ]
                    .filter(Boolean)
                    .join(", ")
            }
            isAlternate={true}
            isLast={false}
          />
          <OrderRow
            type="Phone"
            details={
              isAnon
                ? generateAnonBase64Hash({
                    value: customerDetails?.customerPhone,
                    prefix: "customerPhone",
                    doAnon: isAnon,
                  })
                : customerDetails?.customerPhone
            }
            isAlternate={false}
            isLast={true}
          />
        </div>
      </div>
    </>
  );
};
